import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	pages: [],
	errorMessage: null,
	currentPage: {},
	chatPages: {},
	pollingPages: {},
};

export default function pagesReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_PAGES_SUCCESS:
			return Object.assign({}, state, {
				pages: action.pages,
			});
		case ActionTypes.LOAD_PAGES_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.SELECT_PAGE_SUCCESS:
			return Object.assign({}, state, {
				currentPage: action.page,
			});
		case ActionTypes.RESET_CURRENT_PAGE:
			return Object.assign({}, state, {
				currentPage: {},
			});
		case ActionTypes.SET_CHAT_PAGES:
			return Object.assign({}, state, {
				chatPages: action.chatPages,
			});
		case ActionTypes.SET_POLLING_PAGES:
			return Object.assign({}, state, {
				pollingPages: action.pollingPages,
			});
		default:
			return state;
	}
}
